module.exports = "/fast-coin/img/coin/anim/shine_1/shine_1_021.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/img/coin/anim/shine_1/shine_1_021.png
// module id = 2337
// module chunks = 5